export const WidgetEnum = {
    PERSONALINFO: "PERSONALINFO",
    NOMINEE: "NOMINEE",
    BANKVF: "BANKVF",
    VIDEOKYC: "VIDEOKYC",
    ESIGNTC: "ESIGNTC",
    PVIEWCKYC : "PVIEWCKYC"
  };